import React, { FC, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
// import { Link } from 'react-router-dom';
import { setHeader, setRoutes } from 'src/core/ui/shell';
import { AppConfig, container } from 'src/inversify.config';
import { PermissionSummary, PermissionSummaryStore, PermissionItemStore } from 'src/stores/permissions-store';
import { TableModel, TableView } from 'src/core/ui/collections/table';
import { Card, Row, Tag } from 'antd';
import { Query } from 'src/core/stores/data-store';
import { formatMessage } from 'src/core/services/http.service';
import { AutocompleteTextFilter } from 'src/common/components/table-filters/autocomplete-text-filter';
import { ENV } from 'src/';
import { emptyTableModel } from 'src/common/utils';
// import NewPermissionDialog from './permission-new';
import { AppConfiguration } from 'src/core/services/configuration.service';

const PermissionsListPage: FC = () => {
  const { t } = useTranslation();
  const config: AppConfiguration = useContext(AppConfig);

  const [query, setQuery] = useState({
    searchQuery: '',
    orderBy: [{ field: 'selector', direction: 'Ascending', useProfile: false }],
    skip: 0,
    take: 10,
  } as Query);

  const permissionsStore = container.get(PermissionSummaryStore);
  const permissionsState = permissionsStore.state;
  const permissionFormStore = container.get(PermissionItemStore);
  const permissionFormState = permissionFormStore.state;

  // const [newPermissionVisible, setNewPermissionVisible] = useState(false);

  setHeader(t('Permissions'));
  setRoutes([
    { path: '', breadcrumbName: t('Home') },
    { path: 'permissions', breadcrumbName: t('Permissions') },
  ]);

  useEffect(
    () => {
      permissionsStore.loadPermissions(query);
    },
    [] // eslint-disable-line react-hooks/exhaustive-deps
  );

  const tableModel = {
    query,
    columns: [
      {
        sortable: true,
        searchable: true,
        applyPartialFilter: true,
        filter: <AutocompleteTextFilter baseUrl={permissionsStore.baseUrl} fieldName={'Name'} fieldValue={'name'} />,
        fiterField: 'Name',
        field: 'name',
        title: t('Name'),
        renderer: (data) => (
          // <span>
          //   <Link to={`${match.url}/${data.id}`}>
          <span>{data.name}</span>
          //   </Link>
          // </span>
        ),
      },
      {
        sortable: true,
        searchable: true,
        applyPartialFilter: true,
        filter: <AutocompleteTextFilter baseUrl={permissionsStore.baseUrl} fieldName={'Description'} fieldValue={'description'} />,
        fiterField: 'Description',
        field: 'description',
        title: t('Description'),
        renderer: (data) => <span>{data.description}</span>,
      },
      {
        sortable: true,
        field: 'selector',
        title: t('Selector'),
        renderer: (data) => (
          <span>
            <Tag>{t(data.selector)}</Tag>
          </span>
        ),
      },
    ],
    data: { ...permissionsState.value, isBusy: permissionsState.value.isBusy || permissionFormState.value.isBusy },
  } as TableModel<PermissionSummary>;

  return (
    <Row align="top" justify="space-between">
      <Card className="card-table" style={{ width: '100%' }}>
        <TableView
          rowKey="id"
          canCreateNew={false}
          // onNewItem={() => setNewPermissionVisible(true)}
          // newItemName={t('Add permission')}
          canDelete={false}
          // onDeleteRow={(item: any) => permissionsStore.delete(item.id)}
          canEdit={false}
          canSort
          onQueryChanged={(query: Query) => {
            setQuery(query);
            permissionsStore.loadPermissions(query);
          }}
          onRefresh={() => permissionsStore.loadPermissions(query)}
          model={permissionsState.errorMessage.value ? emptyTableModel : tableModel}
          error={
            permissionsState.errorMessage.value &&
            (config.environment === ENV.DEV ? formatMessage(permissionsState.errorMessage.value) : t('PermissionsTableError'))
          }
        />
        {/* {newPermissionVisible && (
          <NewPermissionDialog
            onClose={(response) => {
              setNewPermissionVisible(false);
              if (response?.identity != null) {
                history.push(`${match.url}/${response.identity}`);
              }
            }}
          />
        )} */}
      </Card>
    </Row>
  );
};

export default PermissionsListPage;
